import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { RequestTypes } from "@enums/request-types";
import { RefreshResult } from "@idw-types/common";

export const refreshAxnConfigRequest = async (): Promise<{ data: Array<RefreshResult>, error: any }> => {
    const route = apiRoutes.managementConsole.axn.config.refresh.all;
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};